import { render, staticRenderFns } from "./ResultPatientsList.vue?vue&type=template&id=4a3eee52&scoped=true&"
import script from "./ResultPatientsList.vue?vue&type=script&lang=js&"
export * from "./ResultPatientsList.vue?vue&type=script&lang=js&"
import style0 from "./ResultPatientsList.vue?vue&type=style&index=0&id=4a3eee52&lang=stylus&scoped=true&"
import style1 from "./ResultPatientsList.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3eee52",
  null
  
)

export default component.exports